// extracted by mini-css-extract-plugin
module.exports = {"formFieldPair":"AssigneePlexTranslationDialog_form-field-pair__1dpMY","formFieldPairText":"AssigneePlexTranslationDialog_form-field-pair-text__1X8mE"};